<template>
<el-container>
 <el-main> 
    <el-form :inline="true" :model="formButlerList" class="demo-form-inline">
        <!-- <el-form-item :label="$t('butler.butlerName')">
          <el-input v-model="formButlerList.butlerRemark" :placeholder="$t('butler.bulter-input')"></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="onSelect">{{$t('butler.qurey')}}</el-button>
          <!-- <el-button type="primary" @click="onCreate">增加网关</el-button> -->
        </el-form-item>
    </el-form>
    <template>
      <el-table :data="tableData" :header-cell-style="{background:'#eef1f6',color:'#606266'}" empty-text="No Data" border>
        <el-table-column type="index" :label="$t('butler.number')" width="100" align="center"></el-table-column>
        <el-table-column prop="roomName" label="房间名称" align="center"></el-table-column>
        <el-table-column prop="roomNo" label="房间编号" align="center"></el-table-column>
        <el-table-column prop="roomTypeName" label="房型名称" align="center"  width="120"></el-table-column>
        <el-table-column prop="status" label="房间状态" align="center"></el-table-column>
        <el-table-column prop="apartmentName" label="公寓名称" align="center" width="120"></el-table-column>
        <el-table-column prop="endTime" label="出租结束时间" align="center"></el-table-column>
      </el-table>
    </template>
  </el-main>
  <el-footer>
    <div>
        <Pagings
          :total="total"
          :offset="pageData.offset"
          :pageSize="pageData.pageNumber"
          @handleSizeChangeSub="handleSizeChange"
          @handleCurrentChangeSub="handleCurrentChange"
        ></Pagings>
    </div>
  </el-footer>    
</el-container>  
</template>
<script>
import Pagings from "../common/Pagings.vue";
export default {
  name: "butlerList", //这个LoginName最好和引入的vue的LoginName相同
   data() {
    return {
      isOnline: this.$route.query.isOnline==undefined?"":this.$route.query.isOnline,
      lowBattery:this.$route.query.lowBattery==undefined?"":this.$route.query.lowBattery,
      pageData: {
        offset: 1,
        pageNumber: 10
      },
      total: 1, //总条数
      tableData: [],
    };
  },
  components: {
    Pagings
  },
   created() {
    this.power();
    // this.butlerApartmentPower();
    // this.getRoleList();
  },
  methods: {
    power() {
      var formData = new FormData();
      formData.append("pageNo", this.pageData.offset);
      formData.append("pageSize", this.pageData.pageNumber);
      if(this.status!=""&&this.status!=null&&this.status!=undefined){
         formData.append("status",this.status);
      }
      this.$server
        .exam("/customer/apartment/listApartmentRoom", formData)
        .then(data => {
          if (data.code == 200) {
            this.tableData = data.data.records;
            this.total = data.data.total;
            // this.oAssEquipmentDto.offset = 1;
            // this.oAssEquipmentDto.pageNumber = data.data.pages;
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },

   
   
    handleSizeChange(val) {
      this.pageData.pageNumber = val;
      this.power();
    },
    handleCurrentChange(val) {
      this.pageData.offset = val;
      this.power();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/statistics/roomStaList.vue